// Dynamic branding - gantikan nama "Destiny Junior" & logo dengan pilihan superadmin
export const DEFAULT_APP_NAME = "Destiny Junior";
const STORAGE_KEY = "custom_app_name";
const LOGO_KEY = "custom_app_logo";
const SLOGAN_KEY = "custom_app_slogan";
const TAGLINE_KEY = "custom_app_tagline";
export const DEFAULT_TAGLINE = "Pengurusan Log Pelajar & Perkembangan";
const BRAND_RE = /destiny\s+junior|taska\s+ummu\s+qaseh/gi;
const BRAND_TEST = /destiny\s+junior|taska\s+ummu\s+qaseh/i;
const TAGLINE_RE = /pengurusan\s+log\s+pelajar\s*(?:&amp;|&)\s*perkembangan|log\s+manja\s+si\s+kecil/gi;
const TAGLINE_TEST = /pengurusan\s+log\s+pelajar\s*(?:&amp;|&)\s*perkembangan|log\s+manja\s+si\s+kecil/i;
const ATTRS = ["placeholder", "title", "alt", "aria-label"];
const LOGO_SRC_TEST = /(logo-destiny\.png|apple-touch-icon\.png|favicon\.(png|ico)|icons\/icon-\d+x\d+\.png|\/logo\.png$)/i;

let appName = (localStorage.getItem(STORAGE_KEY) || DEFAULT_APP_NAME).trim() || DEFAULT_APP_NAME;
let logoUrl = localStorage.getItem(LOGO_KEY) || "";
let appSlogan = localStorage.getItem(SLOGAN_KEY) || "";
let appTagline = localStorage.getItem(TAGLINE_KEY) || "";
let observer = null;

export const getAppName = () => appName;
export const getCustomLogoUrl = () => logoUrl;
export const getAppSlogan = () => appSlogan;
export const getAppTagline = () => appTagline || DEFAULT_TAGLINE;

const nameActive = () => !!appName && appName !== DEFAULT_APP_NAME && !BRAND_TEST.test(appName);
const taglineActive = () => !!appTagline && appTagline !== DEFAULT_TAGLINE && !TAGLINE_TEST.test(appTagline);
const textActive = () => nameActive() || taglineActive();
const TEXT_TEST = (str) => (nameActive() && BRAND_TEST.test(str)) || (taglineActive() && TAGLINE_TEST.test(str));
const logoActive = () => !!logoUrl;

const brandString = (str) => {
  if (nameActive()) str = str.replace(BRAND_RE, (m) => (m === m.toUpperCase() ? appName.toUpperCase() : appName));
  if (taglineActive()) str = str.replace(TAGLINE_RE, (m) => (m === m.toUpperCase() ? appTagline.toUpperCase() : appTagline));
  return str;
};

function brandAttrs(el) {
  if (!el.getAttribute) return;
  if (textActive()) {
    ATTRS.forEach((a) => {
      const v = el.getAttribute(a);
      if (v && TEXT_TEST(v)) el.setAttribute(a, brandString(v));
    });
  }
  if (logoActive() && el.tagName === "IMG") {
    const src = el.getAttribute("src");
    if (src && LOGO_SRC_TEST.test(src) && src !== logoUrl) el.setAttribute("src", logoUrl);
  }
}

function processNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    if (textActive() && TEXT_TEST(node.nodeValue)) node.nodeValue = brandString(node.nodeValue);
    return;
  }
  if (node.nodeType !== Node.ELEMENT_NODE) return;
  const tag = node.tagName;
  if (tag === "SCRIPT" || tag === "STYLE") return;
  brandAttrs(node);
  if (textActive()) {
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let t;
    while ((t = walker.nextNode())) {
      if (TEXT_TEST(t.nodeValue)) t.nodeValue = brandString(t.nodeValue);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll("[placeholder],[title],[alt],[aria-label]").forEach(brandAttrs);
    }
  }
  if (logoActive() && node.querySelectorAll) {
    node.querySelectorAll("img").forEach(brandAttrs);
  }
}

function brandTitle() {
  if (textActive() && TEXT_TEST(document.title)) document.title = brandString(document.title);
  // Brand nama PWA iOS (apple-mobile-web-app-title) & application-name
  if (textActive()) {
    document.querySelectorAll('meta[name="apple-mobile-web-app-title"], meta[name="application-name"]').forEach((m) => {
      const v = m.getAttribute("content");
      if (v && TEXT_TEST(v)) m.setAttribute("content", brandString(v));
    });
  }
}

function brandHeadIcons() {
  if (!logoActive()) return;
  document.querySelectorAll('link[rel*="icon"]').forEach((l) => {
    if (l.href !== logoUrl) l.href = logoUrl;
  });
}

const SPLIT_RE = /^\s*(?:destiny\s*junior|taska\s*ummu\s*qaseh)\s*$/i;

function fixSplitBrand(root) {
  if (!nameActive() || !root || !root.querySelectorAll) return;
  const els = [root, ...root.querySelectorAll("*")];
  els.forEach((el) => {
    const tc = el.textContent;
    if (!tc || !SPLIT_RE.test(tc)) return;
    let deeperMatch = false;
    for (const child of el.children) {
      if (SPLIT_RE.test(child.textContent)) { deeperMatch = true; break; }
    }
    if (deeperMatch) return;
    if (el.childNodes.length < 2) return;
    const isUpper = tc === tc.toUpperCase();
    const name = isUpper ? appName.toUpperCase() : appName;
    const words = name.split(/\s+/);
    // Adakah DOM asal mempunyai ruang sebenar antara perkataan?
    // (Sesetengah komponen letak setiap perkataan/huruf dalam <span> berasingan
    //  tanpa text node ruang - jarak datang dari CSS margin sahaja)
    const hasDomSpace = /\s/.test(tc.trim());

    // Kes 1: container per-perkataan (bil. anak = bil. perkataan, tiada ruang DOM)
    // - tulis setiap perkataan ke dalam anak masing-masing supaya warna/margin kekal
    if (!hasDomSpace && el.children.length === words.length && el.children.length > 1) {
      let allOk = true;
      Array.from(el.children).forEach((child, i) => {
        const twc = document.createTreeWalker(child, NodeFilter.SHOW_TEXT);
        const cNodes = [];
        let cn;
        while ((cn = twc.nextNode())) { if (cn.nodeValue.trim()) cNodes.push(cn); }
        if (cNodes.length === 0) { allOk = false; return; }
        cNodes[0].nodeValue = words[i] || "";
        for (let j = 1; j < cNodes.length; j++) cNodes[j].nodeValue = "";
      });
      if (allOk) return;
    }

    const tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let n;
    while ((n = tw.nextNode())) { if (n.nodeValue.trim()) nodes.push(n); }
    if (nodes.length === 0) return;
    if (nodes.length === 1) { nodes[0].nodeValue = name; return; }

    // Kes 2: tiada ruang DOM (huruf demi huruf / node bersebelahan) -
    // letak nama PENUH (dengan ruang) pada node pertama supaya ruang tidak hilang
    if (!hasDomSpace) {
      nodes[0].nodeValue = name;
      for (let i = 1; i < nodes.length; i++) nodes[i].nodeValue = "";
      return;
    }

    // Kes 3: ada ruang DOM (cth: <span>NAMA1</span> <span>NAMA2</span>) - agih ikut perkataan
    // sambil KEKALKAN whitespace asal di hadapan/belakang setiap node
    // (cth Sidebar: <span>DESTINY</span><span> JUNIOR</span> - ruang berada DALAM span kedua)
    const keepWs = (node, text) => {
      const lead = (node.nodeValue.match(/^\s*/) || [""])[0];
      const trail = (node.nodeValue.match(/\s*$/) || [""])[0];
      node.nodeValue = lead + text + trail;
    };
    keepWs(nodes[0], words[0]);
    keepWs(nodes[1], words.slice(1).join(" "));
    for (let i = 2; i < nodes.length; i++) nodes[i].nodeValue = "";
  });
}

function startObserver() {
  if (observer) return;
  observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "characterData") {
        if (textActive() && TEXT_TEST(m.target.nodeValue)) m.target.nodeValue = brandString(m.target.nodeValue);
      } else if (m.type === "attributes") {
        brandAttrs(m.target);
      } else {
        m.addedNodes.forEach(processNode);
        if (m.target && m.target.nodeType === Node.ELEMENT_NODE) fixSplitBrand(m.target);
      }
    }
    brandTitle();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: [...ATTRS, "src"],
  });
}

function activateBranding() {
  if (!textActive() && !logoActive()) return;
  if (document.body) {
    processNode(document.body);
    fixSplitBrand(document.body);
  }
  brandTitle();
  brandHeadIcons();
  startObserver();
}

export async function initBranding() {
  activateBranding();
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/app-name`);
    if (!res.ok) return;
    const data = await res.json();
    const serverName = (data.app_name || DEFAULT_APP_NAME).trim() || DEFAULT_APP_NAME;
    const serverLogo = data.has_custom_logo
      ? `${process.env.REACT_APP_BACKEND_URL}/api/settings/app-logo?v=${data.logo_version || 1}`
      : "";
    const serverSlogan = (data.app_slogan || "").trim();
    const serverTagline = (data.app_tagline || "").trim();
    const nameChanged = serverName !== appName;
    const logoChanged = serverLogo !== logoUrl;
    const sloganChanged = serverSlogan !== appSlogan;
    const taglineChanged = serverTagline !== appTagline;
    if (!nameChanged && !logoChanged && !sloganChanged && !taglineChanged) return;

    const wasActive = textActive() || logoActive();
    if (serverName === DEFAULT_APP_NAME) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, serverName);
    if (serverLogo) localStorage.setItem(LOGO_KEY, serverLogo);
    else localStorage.removeItem(LOGO_KEY);
    if (serverSlogan) localStorage.setItem(SLOGAN_KEY, serverSlogan);
    else localStorage.removeItem(SLOGAN_KEY);
    if (serverTagline) localStorage.setItem(TAGLINE_KEY, serverTagline);
    else localStorage.removeItem(TAGLINE_KEY);

    if (wasActive && (nameChanged || logoChanged || taglineChanged)) {
      // Branding lama sudah dipaparkan - muat semula untuk paparan bersih
      window.location.reload();
      return;
    }
    appName = serverName;
    logoUrl = serverLogo;
    appSlogan = serverSlogan;
    appTagline = serverTagline;
    activateBranding();
    window.dispatchEvent(new Event("branding-updated"));
  } catch (e) {
    // offline - guna nilai cache localStorage
  }
}
